import React from "react";
import { useNavigate } from "react-router-dom";
import { User, AlertCircle, Edit } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "../../ui";
import { ShadcnButton } from "../../ui";
import { LeadSearchField } from "../fields/LeadSearchField";
import { Lead } from "../../../types";

interface ClientSectionProps {
 leadId: string;
 selectedLead: Lead | null;
 onLeadChange: (leadId: string) => void;
}

export const ClientSection: React.FC<ClientSectionProps> = ({
 leadId,
 selectedLead,
 onLeadChange,
}) => {
 const navigate = useNavigate();
 const hasDocument =
 selectedLead?.document && selectedLead.document.trim() !== "";

 const handleEditLead = () => {
 if (selectedLead?.id) {
 navigate(`/leads/edit/${selectedLead.id}`);
 }
 };

 return (
 <Card>
 <CardHeader>
 <CardTitle className="flex items-center gap-2">
 <User className="h-5 w-5" />
 Cliente
 </CardTitle>
 </CardHeader>
 <CardContent className="space-y-4">
 <LeadSearchField
 value={leadId}
 onChange={onLeadChange}
 placeholder="Buscar cliente por nome, email ou telefone..."
 />

 {selectedLead && (
 <div className="space-y-3">
 <div className="p-4 bg-surface rounded-lg">
 <h4 className="font-medium text-foreground">
 {selectedLead.name}
 </h4>
 <div className="mt-2 space-y-1 text-sm text-muted-foreground">
 {selectedLead.email && <p>Email: {selectedLead.email}</p>}
 {selectedLead.phone && <p>Telefone: {selectedLead.phone}</p>}
 {selectedLead.document && (
 <p>Documento: {selectedLead.document}</p>
 )}
 {selectedLead.assignedUser && (
 <p>Vendedor: {selectedLead.assignedUser.name}</p>
 )}
 </div>
 </div>

 {!hasDocument && (
 <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
 <div className="flex items-start gap-2">
 <AlertCircle className="h-5 w-5 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" />
 <div className="flex-1">
 <p className="text-sm font-medium text-red-800 dark:text-red-200">
 Dados do cliente incompletos
 </p>
 <p className="mt-1 text-sm text-red-700 dark:text-red-300">
 É necessário completar os dados do cliente (documento)
 antes de criar a proposta.
 </p>
 <div className="mt-3">
 <ShadcnButton
 type="button"
 variant="outline"
 size="sm"
 onClick={handleEditLead}
 className="border-red-300 dark:border-red-700 text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/40"
 >
 <Edit className="h-4 w-4 mr-2" />
 Editar Cliente
 </ShadcnButton>
 </div>
 </div>
 </div>
 </div>
 )}
 </div>
 )}
 </CardContent>
 </Card>
 );
};
